import React, { Component } from 'react'
import { PageHeader, message, Icon } from 'antd'
const cardConfig = {
  width: 250,
  title:{
  },
  text:{
    color: 'gray'
  }
}
const textJsx = (cfg) =>`
  <group>
    <rect>
      <rect style={{
        width: ${cardConfig.width},
        height: 20,
        fill: #00b34f,
        radius: [6, 6, 0, 0],
        cursor: 'move',
        stroke: #00b34f
      }} draggable="true">
        <text style={{
          marginTop: 2,
          marginLeft: 75,
          textAlign: 'center',
          fontWeight: 'bold',
          fill: '#fff' }}>{{label}}</text>
      </rect>
      <rect style={{
        width: ${cardConfig.width},
        stroke: #00b34f,
        fill: 'rgba(24,144,255,0.15)',
        radius: [0, 0, 6, 6],
      }}>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>持有人: {{description}}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>粮信面额: {{meta.creatorName}}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>持有金额: {{meta.creatorName}}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>融资金额: {{meta.creatorName}}</text>
        <text style={{ marginTop: 10, marginLeft: 4, fill: 'gray', fontSize: 10}}>转让金额: {{meta.creatorName}}</text>
      </rect>
    </rect>
  </group>
  `
  // tool.popUIByUcv(record.uid, {"currentData":record}, record.taskTitle)
export default class Supplier extends Component {

  createG6 = () => {
        
    G6.registerNode(
      'rect-jsx',
      {
        jsx: textJsx
      }
    );

    const data = {
      nodes: [
        {
          description: 'LX202111030015',
          label: 'node1',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node1',
        },
        {
          description: 'LX202111030015',
          label: 'node2',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node2',
        },
        {
          description: 'LX202111030015',
          label: 'node3',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node3',
        },
        {
          description: 'LX202111030015',
          label: 'node4',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node4',
        },
        {
          description: 'LX202111030015',
          label: 'node5',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node5',
        },
        
        {
          description: 'LX202111030015',
          label: 'node6',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node6',
        },
        {
          description: 'LX202111030015',
          label: 'node7',
          color: '#eadcdc',
          meta: {
            creatorName: 'a_creator',
          },
          id: 'node7',
        },
      ],
      edges: [
        { source: 'node1', target: 'node2' },
        { source: 'node1', target: 'node3' },
        { source: 'node2', target: 'node4' },
        { source: 'node2', target: 'node5' },

        { source: 'node3', target: 'node6' },
        { source: 'node3', target: 'node7' },

      ],
    };

    const container = document.getElementById('container');
    const width = container.scrollWidth;
    const height = container.scrollHeight || 500;
    const graph = new G6.Graph({
      container: 'container',
      width,
      height,
      // fitCenter: true,
      modes: {
        default: [
          {
            // 定义展开/收缩行为
            type: 'collapse-expand',
          },
          'drag-canvas',
          'zoom-canvas',
        ],
      },
      defaultNode: {
        type: 'rect-jsx',
        labelCfg: {
          style: {
            fill: '#000000A6',
            fontSize: 10,
          },
        },
        style: {
          stroke: '#72CC4A',
          width: 150,
        },
      },
      defaultEdge: {
        // ...                 // 边的其他配置
        type: 'polyline',
        // 边样式配置
        style: {
          opacity: 0.6, // 边透明度
          stroke: '#00b34f', // 边描边颜色
          endArrow: true,
        },
      },
      layout: {
        type: 'dagre', // 布局类型
        rankdir: 'LR', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
        nodesep: 60,
        ranksep: 100,
        sortByCombo: true
        // direction: 'TB', // 自左至右布局，可选的有 H / V / LR / RL / TB / BT
        // nodeSep: 50, // 节点之间间距
        // rankSep: 100, // 每个层级之间的间距
      },
    });

    graph.data(data);
    graph.render();

    if (typeof window !== 'undefined')
      window.onresize = () => {
        if (!graph || graph.get('destroyed')) return;
        if (!container || !container.scrollWidth || !container.scrollHeight) return;
        graph.changeSize(container.scrollWidth, container.scrollHeight);
      };
  }
  componentDidMount(){
    this.createG6()
  }
  render() {
    return (
      <div>
        {/* <PageHeader
          style={{
            borderBottom: '1px solid rgb(235, 237, 240)',
          }}
          onBack={() => null}
          title="牛信流转图"
        /> */}
        <div id="container"></div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Supplier/index.js